
<div v-if="site" class="v-flex" style="width: calc(100% + 10px)">
    <d-image-folder-create
        v-model  = "showCreate"
        :site    = "site"
        @created = "onFolderCreated"
    />
    <input
        ref      = "fileInput"
        type     = "file"
        multiple
        :accept  = "accept"
        style    = "display: none"
        @change  = "onFilesPicked"
    />
    <div v-if="loading" class="img-loading">
        <v-progress-circular indeterminate color="primary" size="48" />
    </div>
    <div
        style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px"
        v-if="folders && folders.length === 0"
    >
        <v-card>
            <v-card-text>{{ $t('img.folder.create.empty') }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="showCreate = true">
                    {{ $t('img.folder.create.action') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

    <div class="w-100 v-flex h-100" v-if="folders && folders.length > 0">
        <div class="d-flex flex-column align-self-start" style="width: 400px; min-width: 300px;">
        <v-tabs
            :key    = "tabsKey"
            show-arrows
            v-model = "folderIndex"
            class   = "ma-0 pa-0 mt-2 folder-tabs"
            @change = "onFolder"
            vertical
            style="width: 100%;"
        >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
                v-for        = "(folder,index)  in folders"
                :key         = "index"
                active-class = "folder-tab-active primary"
                class        = "folder-tab"
            >
                <div v-if="!folder.date">
                    <div class="folder-date">
                        {{ $t( 'image.category.common' )}}
                    </div>
                    <div class="folder-name">
                        {{ folderLabel (folder) }}
                    </div>
                </div>
                <div v-if="folder.date">
                    <div class="folder-date">
                        {{ formatDate (folder.date) }}
                    </div>
                    <div class="folder-name">
                        {{ folderLabel (folder) }}
                    </div>
                </div>
            </v-tab>
        </v-tabs>
        <div class="mt-2">
            <v-btn text small color="primary" @click="showCreate = true">
                <v-icon left small>mdi-folder-plus</v-icon>
                {{ $t('img.folder.create.action') }}
            </v-btn>
        </div>
        </div>
        <v-container
            class="img-panel mt-2"
            @dragenter.prevent = "onDragEnter"
            @dragover.prevent
            @dragleave.prevent = "onDragLeave"
            @drop.prevent      = "onDrop"
        >
            <div class="drop-overlay" v-if="dragging">
                <v-icon x-large color="primary">mdi-upload</v-icon>
                <div>{{ $t('img.upload.drop') }}</div>
            </div>
            <div style="height: 740px; overflow-y: scroll; padding-right: 1px; width: 100%;" v-if="folder" :key="refresh" >
                <div class="image-overlay" v-if="carousel"></div>

                <div class="folder-actions">
                    <v-btn text small color="primary" @click="$refs.fileInput.click()">
                        <v-icon left small>mdi-upload</v-icon>
                        {{ $t('img.upload.action') }}
                    </v-btn>
                    <v-btn
                        text small color="primary"
                        :loading  = "downloading"
                        :disabled = "!images || images.length === 0"
                        @click    = "onDownloadFolder"
                    >
                        <v-icon left small>mdi-download</v-icon>
                        {{ $t('img.download.action') }}
                    </v-btn>
                    <span class="folder-empty" v-if="images && images.length === 0">
                        {{ $t('img.folder.create.noimages') }}
                    </span>
                </div>

                <div class="image-zoom" v-if="carousel" style="max-width: 62%; margin-left: 8%">
                    <div style="position: absolute; right: 25px; top: 22px; z-index: 999; width: 25px">
                        <v-btn fab color="primary" @click="onClose" small >
                            <v-icon >mdi-close</v-icon>
                        </v-btn>

                        <v-btn fab color="primary" @click="onMax" small class="mt-3" >
                            <v-icon >mdi-arrow-expand-all</v-icon>
                        </v-btn>

                        <v-btn fab color="primary" @click="onDownloadImage" small class="mt-3" >
                            <v-icon >mdi-download</v-icon>
                        </v-btn>
                    </div>
                    <v-carousel
                        hide-delimiters
                        show-arrows-on-hover
                        height="750"
                        class="mt-5"
                        v-model="position"
                    >
                        <v-carousel-item
                            v-for="image in images"
                            :key="image.id"
                        >
                            <img-image
                                :id="image.id" :item="image" :image="true"
                            />
                        </v-carousel-item>
                    </v-carousel>
                </div>

                <v-row style=" margin-left: -2px; margin-top: -2px;">
                    <v-col
                        v-for="(image, index) in images"
                        :key="image.id"
                        class="d-flex child-flex image-col"
                        :cols="cols"
                    >
                        <div>
                            <a @click="onSelect(index)">
                                <img-image :id="image.id" :item="image" />
                            </a>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</div>
